import type { Key } from "react-aria-components";
import { Tab, TabList, Tabs } from "react-aria-components";

import { cn } from "@/lib/helpers/cn";

type TabListProps = {
  className?: string;
  onTabChange: (tab: string) => void;
  selectedTab: string;
  tabs: string[];
};

export function ProfileTabList({ className, onTabChange, selectedTab, tabs }: TabListProps) {
  return (
    <Tabs
      keyboardActivation="manual"
      onSelectionChange={(key: Key) => onTabChange(String(key))}
      selectedKey={selectedTab}
    >
      <TabList
        aria-label="Patient profile navigation"
        className={cn("tw:flex tw:w-full tw:justify-between", className)}
        data-e2e="patient-chart-header-tabs"
      >
        {tabs.map((tab) => (
          <Tab
            className={cn(
              "tw:rounded-t-sm tw:px-5 tw:py-5",
              "tw:text-sm tw:font-semibold tw:text-text-tertiary",
              "tw:cursor-pointer",
              "tw:hover:text-text-teal-primary",
              "tw:selected:border-b-2 tw:selected:border-stroke-teal-primary tw:selected:text-text-teal-primary",
              "atom-keyboard-focus",
            )}
            id={tab}
            key={tab}
          >
            {tab}
          </Tab>
        ))}
      </TabList>
    </Tabs>
  );
}
